"use client";

import { useState, useEffect } from "react";
import Image from "next/image";
import { archivements } from "@/lib/data";
import styles from "./achievements.module.css";

export default function AchievementsSection() {
  const [currentAchievement, setCurrentAchievement] = useState(0);

  useEffect(() => {
    let isMounted = true;
    let timeoutId: NodeJS.Timeout;
    
    const scheduleNext = () => {
      timeoutId = setTimeout(() => {
        if (isMounted) {
          setCurrentAchievement((prev) => (prev + 1) % archivements.length);
          scheduleNext();
        }
      }, 4000);
    };
    
    scheduleNext();

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, []);

  const nextAchievement = () => {
    setCurrentAchievement((prev) => (prev + 1) % archivements.length);
  };

  const prevAchievement = () => {
    setCurrentAchievement((prev) => (prev - 1 + archivements.length) % archivements.length);
  };

  return (
    <section className={styles.achievements}>
      <div className={styles.achievementsHeader}>
        <p className={styles.achievementsTag}>Những gì khách hàng nhận xét</p>
        <h2 className={styles.achievementsTitle}>Thành tựu nổi bật</h2>
        <p className={styles.achievementsDesc}>
          Những cột mốc quan trọng, khẳng định chất lượng và sự tin tưởng của
          khách hàng
        </p>
      </div>
      <div className={styles.achievementsCarouselWrapper}>
        <button
          className={styles.achievementsArrow}
          onClick={prevAchievement}
          aria-label="Xem thành tựu trước đó"
        >
          <Image
            src="/assets/sdtc-image/icon/CircleArrowLeft.svg"
            alt="Mũi tên trái"
            className={styles.customIconHomePage}
            width={32}
            height={32}
            loading="lazy"
            decoding="async"
          />
        </button>
        <div className={styles.achievementsCarousel}>
          <div 
            className={styles.achievementsSlidesContainer}
            data-current={currentAchievement}
          >
            {archivements.map((achievement, index) => (
              <div key={index} className={styles.achievementSlide}>
                <div className={styles.achievementVisual}>
                  <Image
                    className={styles.bigQuoteSvg}
                    src="/assets/sdtc-image/icon/quote.svg"
                    alt="Dấu ngoặc kép"
                    width={200}
                    height={200}
                    loading="lazy"
                    decoding="async"
                  />
                  <div className={styles.achievementLogo}>
                    <Image
                      src={achievement.logo}
                      alt={achievement.company}
                      width={180}
                      height={80}
                      loading="lazy"
                      decoding="async"
                      quality={80}
                    />
                  </div>
                </div>
                <p className={styles.achievementContent}>
                  {achievement.content}
                </p>
                <div className={styles.achievementAuthor}>
                  <div className={styles.authorName}>
                    {achievement.author}
                  </div>
                  <div className={styles.authorRole}>
                    {achievement.role}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <button
          className={styles.achievementsArrow}
          onClick={nextAchievement}
          aria-label="Xem thành tựu tiếp theo"
        >
          <Image
            src="/assets/sdtc-image/icon/CircleArrowRight.svg"
            alt="Mũi tên phải"
            className={styles.customIconHomePage}
            width={32}
            height={32}
            loading="lazy"
            decoding="async"
          />
        </button>
      </div>
    </section>
  );
}